import { render, staticRenderFns } from "./Change.vue?vue&type=template&id=0c79bbbd&scoped=true&"
import script from "./Change.vue?vue&type=script&lang=js&"
export * from "./Change.vue?vue&type=script&lang=js&"
import style0 from "./Change.vue?vue&type=style&index=0&id=0c79bbbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c79bbbd",
  null
  
)

export default component.exports